import { LocalizedTheme } from '@philips-internal/oswald-ui-constants';
import { ComponentType } from '@philips-internal/oswald-ui-core';
import { eventListener, expression, listOf, number, oneOf, shape, string } from '@philips-internal/oswald-ui-core/lib/component/prop-types/index.js';
import { enumValues } from '@philips-internal/oswald-ui-utils';
const HeadingProperties = {
    className: {
        type: string,
    },
    container: {
        type: shape({
            acceptedTypes: listOf(oneOf(enumValues(ComponentType))),
            name: string,
        }).notEnumerable(),
    },
    inlineActionsDesktopLimit: {
        defaultValue: 4,
        type: number,
    },
    onBeforeClose: {
        type: eventListener,
    },
    onClose: {
        type: eventListener,
    },
    onOpen: {
        type: eventListener,
    },
    theme: {
        defaultValue: LocalizedTheme.DEFAULT,
        type: oneOf(enumValues(LocalizedTheme)),
    },
    title: {
        type: expression,
    },
    uuid: {
        defaultValue: '',
        type: string,
    },
};
export { HeadingProperties, };
//# sourceMappingURL=heading-types.js.map